import { payment_method } from '../../utils/constants/misc'
import { equalityOperators, multiselectOperators, dateOperators, textOperators } from '../../utils/constants/operators'
import ListModule from '../module/ListModule'
import React from 'react'
import Link from '../navigation/Link'
import { Typography } from '@mui/material'

const OutcomeSubModule = ({ userRight, user, location }) => {
  const supplierId = location?.state?.id ?? null

  const options = {
    tableStyle: { maxHeight: 350, padding: '1px' },
    paperStyle: {},
    objectType: 'outcomes',
    accessRight: userRight,
    actions: { go: true },
    objectFilter: () => ({ supplier_id: supplierId, company_id: user.company_id }),
    isFilter: true,
    defaultSorted: 'date',
    columns: [
      { name: 'periodYear', label: 'Année', isFilter: true, operators: dateOperators },
      { name: 'periodMonth', label: 'Mois', isFilter: true, operators: dateOperators },
      { name: 'periodYearMonth', label: 'Période', isFilter: true, operators: dateOperators },
      {
        name: 'date',
        label: 'Date',
        inputType: 'date',
        type: 'date',
        format: 'DD/MM/YYYY',
        isFilter: true,
        operators: dateOperators
      },
      {
        name: 'invoice_number',
        label: 'N° Facture',
        isFilter: true,
        operators: textOperators,
        mapping: (id, rowid) => (
          <Typography component='span'>
            <Link to={`/outcomes/view`} state={{ id: rowid.id, history: '/suppliers/view' }}>
              {id}
            </Link>
          </Typography>
        )
      },
      { name: 'amount', label: 'Montant', type: 'currency', isFilter: false },
      { name: 'description', label: 'Description', isFilter: false },
      {
        name: 'payment_method',
        label: 'Méthode payement',
        isFilter: true,
        values: payment_method,
        valueEditorType: 'multiselect',
        operators: [...equalityOperators, ...multiselectOperators],
        mapping: (name) => {
          const result = payment_method.find((item) => item.name === name?.toString())
          return result ? result.label : name
        }
      }
    ]
  }

  const toolbar = {
    isFilter: true,
    columns: options.columns,
    isSubMod: true,
    style: { marginTop: '5px', marginBottom: '5px' },
    objectType: 'outcomes',
    accessRight: userRight,
    actions: { addFor: true },
    getContext: () => ({ supplier_id: supplierId }),
    columnVisibility: true
  }

  return <ListModule options={options} toolbar={toolbar} />
}

export default React.memo(OutcomeSubModule)
